import React, { createContext, useState, useContext } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(false);

  const openModal = (modalName) => {
    if (!activeModal) {
      setActiveModal(modalName);
    }
  };

  const closeModal = () => {
    setActiveModal(false);
  };

  return (
    <ModalContext.Provider value={{ activeModal, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);

